export const LEFT_SIDE_BAR = false;
export const TIME_LOGOUT= 3000;
export const SIZE_PAGINATION= 10;

export const PATH= '';
export const TOKEN_STRING= 'Bearer ';
export const APP_SALT= "]7$Mt[$;:LM6-9XK{g7Q"

// COOKIES
export const ID_TOKEN = 'token_Jemma_consultas_system';
export const CLIENT_ID = '2rqigv2ea65i4o75rdupioglq4';
